/**
 * API configuration for frontend.
 * Uses VITE_API_BASE environment variable in production,
 * falls back to empty string (relative path) for local development.
 */
export const API_CONFIG = {
  /**
   * Base URL for API requests.
   * Production: https://api.admission.suido.net
   * Development: '' (uses Vite proxy or relative paths)
   */
  BASE_URL: import.meta.env.VITE_API_BASE || '',
} as const;

/**
 * Constructs a full API URL.
 * @param path - API path starting with /api/
 * @returns Full URL with base prepended in production
 */
export function apiUrl(path: string): string {
  return `${API_CONFIG.BASE_URL}${path}`;
}

/**
 * Get API base URL for a specific endpoint.
 * @param endpoint - Endpoint path like '/api/exams'
 * @returns Full URL
 */
export const getApiBase = (endpoint: string): string => apiUrl(endpoint);
